const login = {
  login: 'Connexion',
  phone: 'Téléphone',
  email: 'Email',
  erCode: 'Code QR',
  phoneNo: 'Numéro de téléphone',
  sryx: 'Veuillez entrer l email',
  password: 'Mot de passe',
  wjmm: 'Mot de passe oublié ?',
  srmm: 'Veuillez entrer le mot de passe',
  myzh: 'Pas encore de compte ?',
  ljzc: 'S inscrire maintenant',
  cxsm: 'Rafraîchissez et rescanez avec l app Biking',
  xydl: 'Veuillez confirmer sur votre téléphone',
  smewm: 'Cliquez sur l icône profil dans l app Biking, puis scannez le code QR en haut à droite',
  qtfs: 'Autres méthodes de connexion',
  ggsfyz: 'Authentification Google',
  bdsj: 'Vous avez lié un téléphone',
  bdyx: 'Vous avez lié un email',
  fsyzm: 'Envoyer le code de vérification',
  wcyz: 'Veuillez compléter la vérification',
  dlcg: 'Connexion réussie, bienvenue sur Biking !',
  bktb: 'Pour des raisons de sécurité, les retraits sont bloqués pendant 24h après modification des paramètres de sécurité',
  fhdl: 'Retour à la page de connexion',
  jx: 'Continuer',
  cxfs: 'Renvoyer',
  gxmm: 'Mettre à jour le mot de passe',
  srsjh: 'Veuillez entrer le numéro de téléphone',
  wjmm1: 'Mot de passe oublié',
  sryxdz: 'Veuillez entrer l adresse email',
  srzqyx: 'Veuillez entrer une adresse email valide',
  sryzm: 'Entrer le code de vérification',
  czmm: 'Réinitialiser le mot de passe',
  sbdyzm: 'Pas reçu le code ?',
  srxmm: 'Veuillez entrer un nouveau mot de passe',
  zczh: 'Créer un compte Biking',
  yqm: 'Code d invitation (optionnel)',
  sryqm: 'Veuillez entrer le code d invitation',
  zc: 'S inscrire',
  yyzh: 'Déjà un compte ?',
  ljdl: 'Se connecter maintenant',
  fsz: 'Code envoyé à',
  next: 'Suivant',
  szmm: 'Définir le mot de passe',
  submit: 'Soumettre',
  zccg: 'Inscription réussie !'
}
const download = {
  title: 'Jeux diversifiés et<br/>Plateforme de trading de cryptomonnaies',
  subTitle: 'Biking permet de trader des dizaines de cryptomonnaies',
  xzbw: 'Pourquoi choisir Biking',
  czzz: 'Biking vous aide à créer, augmenter et protéger vos richesses',
  download: 'Télécharger sur App Store',
  downloadtf: 'Télécharger sur TestFlight',
  cjqxz: 'Téléchargement Super Signature',
  cjq: 'Super Signature {index}',
  bdxz: 'Téléchargement local',
  ggpxz: 'Télécharger sur Google Play',
  advantageTitle1: 'Performance optimale · Trading ultra-rapide',
  subTitleSubTitle1: 'Technologie de la Bourse de Londres, ultra-faible latence',
  advantageTitle2: 'Protection des actifs · Sécurité maximale',
  subTitleSubTitle2: 'Biking respecte les normes CCSS',
  advantageTitle3: 'Service 24h/24',
  subTitleSubTitle3: 'Système opérationnel en continu, support client disponible',
  qhidxq: 'Détails du changement d ID',
  step1: 'Étape 1',
  step2: 'Étape 2',
  step3: 'Étape 3',
  step4: 'Étape 4',
  step5: 'Étape 5',
  step6: 'Étape 6',
  step7: 'Étape 7',
  step8: 'Étape 8',
  step9: 'Étape 9',
  step10: 'Étape 10',
  azBiking: 'Installer Biking via App Store',
  dlxz: 'Si vous avez un ID App Store non-chinois, téléchargez directement',
  fdlid: 'Préparez un ID App Store non-chinois',
  yxfshq: 'Si vous n avez pas d ID non-chinois, vous pouvez essayer ces méthodes',
  qhid: 'Changer d Apple ID sur App Store',
  dk: '1. Ouvrir',
  ysjtx: 'l App Store, cliquez sur l icône en haut à droite',
  cxsrmm: '2. Cliquez sur déconnexion, puis entrez l Apple ID et le mot de passe',
  wfdl: '* Si "connexion impossible", attendez quelques heures ou changez d ID',
  azapp: 'Installer l app',
  storesh: '1. Après connexion,irez au App Store régional, recherchez "Biking" et cliquez "Get"',
  jxxz: 'J ai un ID Apple non-chinois, continuer le téléchargement',
  jxxz1: 'Continuer le téléchargement',
  way1: 'Méthode 1',
  wayTitle1: 'S inscrire soi-même, sûr et stable',
  wayBtn1: 'Voir comment s inscrire',
  way2: 'Méthode 2',
  wayTitle2: 'ID de référence (pratique)',
  wayBtn2: 'Voir les ID de référence',
  way3: 'Méthode 3',
  wayTitle3: 'Guide par région (flexible)',
  wayBtn3: 'Voir comment acheter',

  ckzh: 'Comptes de référence Apple ID non-chinois',
  jgck: 'IDs de régions étrangères pour référence',
  jjfz: '(Cliquez pour copier)',
  zh: 'Compte',
  mm: 'Mot de passe',
  xxxl: 'Pour protéger vos données',
  dlicloud: 'Veuillez NE PAS utiliser ces IDs pour iCloud',
  tczh: 'Après téléchargement, veuillez vous déconnecter',
  cfsy: 'Ne liez pas de numéro de téléphone, sinon l ID ne pourra plus être utilisé',
  jrql: 'Scanner le QR code pour rejoindre le groupe',
  lxkf: 'Contacter le support',

  zjzc: 'S inscrire soi-même pour un ID 海外',
  registerStep1: 'Étape 1 Ouvrir la page Apple ID',
  registerStep2: 'Étape 2 Vérifier l email',
  registerStep3: 'Étape 3 Se déconnecter du compte App Store',
  registerStep4: 'Étape 4 Se connecter avec l ID nouvellement enregistré',
  gwzcwz: 'Ouvrez le site d inscription Apple dans Safari :',
  yzdzyx: 'Après avoir rempli les informations, vous recevrez un email de vérification.',
  tjfkfs: 'Ensuite, allez sur la page de gestion Apple ID, cliquez sur paiement et livraison.',
  mgsfzsc: 'Moment clé : vérifiez que le paiement est sur "Aucun", pays/région sur USA ou autre.',
  gxdqxx: 'Cliquez sur Mettre à jour après avoir rempli.',
  zhxx: '1. Ouvrir App Store, cliquer sur l icône en haut à droite',
  djwc: '2. Faire défiler vers le bas, cliquer "Se déconnecter"',
  jrzhdl: '1. Cliquer sur l icône en haut à droite',
  zhmmdl: '2. Entrer le compte et le mot de passe, cliquer "Se connecter"',
  jydlcg: '3. Entrer le code de vérification, connexion réussie',
  jysssd: 'Trader partout',
  smewm: 'Scanner le code QR',
  xiazai: 'Télécharger',
  huodong: 'Activité',
  title1: 'Biking Jeux diversifiés',
  title2: 'et plateforme de trading de cryptomonnaies',
  open: 'Ouvrir dans l app "Biking"',
  ggzx: 'Centre d annonces',
  lscb: 'Dépôt chaîne',
  fbrj: 'Dépôt fiat',
  tgaq: 'Offrir des services de trading plus sécurisés',
  wdjmzc: 'de produits dérivés cryptographiques stables',
  szhbjy: 'Trading de cryptomonnaies professionnel',
  yxhsjh: 'S inscrire par email/téléphone',

  appBetaTag: 'Version BETA officiellement lancée',
  appHeroTitle: 'Mise à niveau majeure de l app',
  appHeroSubtitle: 'Ouvrez une nouvelle voie de trading avec Biking',
  tryNow: 'Essayer maintenant',
  downloadBikingApp: 'Télécharger l app Biking',
  roadmapStageMeta: '/{total} {phase}',
  roadmapPhase1: 'Phase 1',
  roadmapPhase2: 'Phase 2',
  roadmapPhase3: 'Phase 3',
  roadmapPhase4: 'Phase 4',
  roadmapPhase5: 'Phase 5',
  roadmapVisionTitle: 'Refonte visuelle',
  roadmapVisionDesc: 'Nouveau langage de design · Interactions raffinées · Expérience immersive',
  roadmapVisionPoint1: 'Nouveau langage de design',
  roadmapVisionPoint2: 'Interactions raffinées',
  roadmapVisionPoint3: 'Expérience immersive',
  roadmapEngineTitle: 'Mise à niveau du moteur de performance',
  roadmapEngineDesc: 'Architecture centrale reconstruite · Réponse en millisecondes · Stabilité maximale',
  roadmapEnginePoint1: 'Architecture centrale reconstruite',
  roadmapEnginePoint2: 'Réponse en millisecondes',
  roadmapEnginePoint3: 'Stabilité maximale',
  roadmapBetaTitle: 'Lancement Beta',
  roadmapBetaDesc: 'Système de trading nouvelle génération · Appariement ultra-rapide · Accès limité',
  roadmapBetaPoint1: 'Système de trading nouvelle génération',
  roadmapBetaPoint2: 'Appariement ultra-rapide',
  roadmapBetaPoint3: 'Accès limité',
  roadmapGlobalTitle: 'Évolution complète de la plateforme',
  roadmapAiTitle: 'Ère du trading IA',
  comingSoon: 'Bientôt disponible',
  appCopyright: '© 2016-2026 BiKing. Tous droits réservés.',
  testFlight: 'Test Flight',
  appStore: 'App Store',
  googlePlay: 'Google Play',
  superSign: 'Super Sign',
  chooseDownload: 'Choisir le mode de téléchargement',
  downloadAddr1: 'Adresse de téléchargement 1',
  downloadAddr2: 'Adresse de téléchargement 2',
  downloadCancel: 'Annuler',
  apkLocalDownload: 'Télécharger l APK',
  entryBetaTitle: 'Version Beta disponible',
  entryBetaSubtitle: 'Découvrez les dernières fonctionnalités en avant-première',
  entryBetaTitleFull: 'Version Beta disponible — découvrez les dernières fonctionnalités en avant-première !',
  entryDownloadNow: 'Télécharger',
  entryTagNew: 'New',
  entryClose: 'Fermer',
}
export {login, download}


// WEBPACK FOOTER //
// ./src/i18n/lang/login/fr.js